import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { GoogleAuthProvider } from '@/components/auth';
import { queryClient } from '@/services/query-client';
import { installGlobalErrorHandlers } from '@/utils/error-reporter';
import { router } from './router';
import './index.css';

installGlobalErrorHandlers();

const enableMocking = async (): Promise<void> => {
  if (import.meta.env.VITE_ENABLE_MOCKS !== 'true') {
    return;
  }
  const { worker } = await import('./test/mocks/browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },
  });
};

enableMocking()
  .catch(() => {})
  .then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <GoogleAuthProvider>
            <RouterProvider router={router} />
            <ReactQueryDevtools initialIsOpen={false} />
          </GoogleAuthProvider>
        </QueryClientProvider>
      </React.StrictMode>,
    );
  });
